import { render, staticRenderFns } from "./RiskCategorySelect.vue?vue&type=template&id=9d0525ce&"
import script from "./RiskCategorySelect.vue?vue&type=script&lang=ts&"
export * from "./RiskCategorySelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports